export const DEFAULT_ALLOWED_TAGS = [
  'blockquote',
  'br',
  'div',
  'em',
  'h1',
  'h2',
  'h3',
  'li',
  'ol',
  'p',
  's',
  'strong',
  'u',
  'ul',
] as const;
